module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Black.303f6a53.ttf";